import services from '@/utils/request';

// 注册
export function register(data, headers) {

    return services.request({
        method: 'POST',
        url: "/auth/register",
        headers: headers,
        data: data
    })
}

// 获取code
export function code(data) {

    return services.request({
        method: 'GET',
        url: "/resource/sms/code",
        params: data
    })
}

// 登录
export function login(data, headers) {

    return services.request({
        method: 'POST',
        url: "/auth/login",
        headers: headers,
        data: data

    })
}
// 退出登录
export function logout(data, headers) {
    return services.request({
        method: 'POST',
        url: "/auth/logout",
 
    })
}
// 登录成功后获取用户信息
export function getInfo() {
    return services.request({
        method: 'GET',
        url: "/auth/getInfo",

    })
}
// 店铺授权
export function getShopAuthUrl(params) {
    return services.request({
        method: 'GET',
        url: `/auth/getShopAuthUrl/${params.callback}/${params.type}`,


    })
}
export function loginOne(data, headers) {

    return services.request({
        method: 'POST',
        url: "/auth/login",
        headers: headers,
        data: data

    })
}

export function getShopAuthUrls() {

    return services.request({
        method: 'GET',
        url: "/auth/getShopAuthUrls",
    

    })
}
